<template>
  <div class="enjoy-area pt-100">
    <div class="container">
      <div class="row align-items-center">
        <div
          class="col-lg-6"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-delay="100"
        >
          <div class="enjoy-img">
            <img src="@/assets/images/enjoy.png" alt="enjoy" />
          </div>
        </div>

        <div
          class="col-lg-6"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-delay="200"
        >
          <div class="enjoy-content">
            <span class="top-title">متعة المشاهدة</span>
            <h2>استمتع بالرياضة، الأفلام، البرامج التلفزيونية والمزيد</h2>
            <p>
              مع مجموعتنا الواسعة والشاملة من القنوات التلفزيونية ومكتبة الأفلام والمسلسلات المحدثة يومياً، لن تفوتك مباريات فريقك المفضل أو عروضك الترفيهية الحصرية بعد اليوم.
            </p>
            <h4>اشترك الآن واحصل على تجربة مجانية فورية قبل الدفع</h4>
            <div class="row align-items-center mb-30">
              <div class="col-lg-4 col-sm-6">
                <div class="starting-form mb-sm-0">
                  <span>تبدأ الأسعار من</span>
                  <h1>30<sub> يورو/سنة</sub></h1>
                </div>
              </div>
              <div class="col-lg-8 col-sm-6">
                <div class="nestor-prepaid">
                  <span>دعم فني وتحديثات مستمرة</span>
                  <h3>ادفع فقط مقابل فترة الاشتراك بدون أي عقود التزام</h3>
                  <a
                    href="https://wa.me/447429916178"
                    target="_blank"
                    class="read-more style-two text-grey-teal"
                  >
                    اطلب تجربتك المجانية الآن
                    <i class="ti ti-arrow-left"></i>
                  </a>
                </div>
              </div>
            </div>
            <a href="https://wa.me/447429916178" target="_blank" class="btn bg-grey-teal">
              <span class="border-style">استفسر عن باقات الأسعار عبر الواتساب</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "EnjoySports",
});
</script>